// Use this import if you want to use "env.js" file
// const { API_URL } = require("../../config/env")
// Or just specify it directly like this:
const API_URL =
  process.env.API_URL || 'https://oceanflowapi.incubator.com.ar/api/';

const API_CHAT_URL =
  process.env.API_CHAT_URL || 'https://chat.zazu.com.es/api/';

/**
 * The options used to configure the API.
 */
export interface ApiConfig {
  /**
   * The URL of the api.
   */
  url: string;

  /**
   * Milliseconds before we timeout the request.
   */
  timeout: number;
}

/**
 * The default configuration for the app.
 */
export const DEFAULT_API_CONFIG: ApiConfig = {
  url: API_URL,
  timeout: 20000
};

export const DEFAULT_API_CHAT_CONFIG: ApiConfig = {
  url: API_CHAT_URL,
  timeout: 20000
};
